import { LoginProvider, TokenResponse, UserInfo } from '../types/authorization';
import { getMarketSegment } from '../utils';
import { channel, ContextualizationApi, vfCountryCode, vfProject } from '@vfmfe/foundations';
import { httpClient } from '../modules/httpClient';

//DEV
//export const BASE_URL_AUTHZ = 'https://authz-digital-ts-dev.non-prod.pt-digital.engineering.vodafone.com';
//export const BASE_URL_API = 'https://apiservices-dev.pt.internal.vodafone.com';
//PRE
export const BASE_URL_AUTHZ = 'https://authz-digital-ts-pre.non-prod.pt-digital.engineering.vodafone.com';
export const BASE_URL_API = 'https://apiservices-pre.pt.internal.vodafone.com';
export const BASE_URL_AUTHX2 = 'https://aws-api-pre.non-prod.pt-digital.engineering.vodafone.com';

export const GET_CONTEXTUALIZATION_URL = `${BASE_URL_API}/contextualization/v2/contextualization/`;
export const GET_LOGIN_PROVIDERS_URL = `${BASE_URL_AUTHZ}/digital/authz/v1/oauth2/providers`;
export const POST_TOKEN_URL = `${BASE_URL_AUTHZ}/digital/authz/v1/oauth2/token`;
export const GET_USER_INFO_URL = `${BASE_URL_AUTHX2}/authx2-ts/userinfo`;
export const COGNITO_URL = `https://cognito-idp.eu-west-1.amazonaws.com/`;
export const getLoginProviders = () => {
    return window.HttpClient.get<LoginProvider[]>(GET_LOGIN_PROVIDERS_URL);
};

export const postToken = (code?: string, state?: string) => {
    return window.HttpClient.post<TokenResponse>(POST_TOKEN_URL, {
        code,
        state,
        grant_type: code ? 'authorization_code' : 'client_credentials'
    });
};

export const refreshToken = (refreshToken?: string) => {
    return window.HttpClient.post<TokenResponse>(POST_TOKEN_URL, {
        refresh_token: refreshToken,
        grant_type: 'refresh_token'
    });
};

export const getUserInfo = () => {
    return window.HttpClient.get<UserInfo>(GET_USER_INFO_URL);
};

export const contextualizationApi = new ContextualizationApi.ContextualizationApi(httpClient);

export const getContextualization = ({ id, type }: { id: string; type: string }) => {
    return contextualizationApi.getContextualization(channel, vfCountryCode, vfProject, id, type, getMarketSegment());
};

export const getContextualizationTree = ({ id, type }: { id: string; type: string }) => {
    return contextualizationApi.getContextualizationTree(
        channel,
        vfCountryCode,
        vfProject,
        id,
        type,
        getMarketSegment()
    );
};

export const amigoLogin = (clientId: string, username: string, password: string) => {
    return window.HttpClient.post(
        COGNITO_URL,
        {
            ClientId: clientId,
            AuthFlow: 'USER_PASSWORD_AUTH',
            AuthParameters: {
                USERNAME: username,
                PASSWORD: password
            }
        },
        {
            headers: {
                'x-amz-target': 'AWSCognitoIdentityProviderService.InitiateAuth',
                'content-type': 'application/x-amz-json-1.1'
            }
        }
    );
};
